var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationPoint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1673 9.58341C19.1673 14.3684 13.8591 19.3517 12.0766 20.8908C11.9106 21.0157 11.7084 21.0832 11.5007 21.0832C11.2929 21.0832 11.0907 21.0157 10.9247 20.8908C9.14219 19.3517 3.83398 14.3684 3.83398 9.58341C3.83398 7.55009 4.64172 5.60004 6.0795 4.16226C7.51728 2.72448 9.46733 1.91675 11.5007 1.91675C13.534 1.91675 15.484 2.72448 16.9218 4.16226C18.3596 5.60004 19.1673 7.55009 19.1673 9.58341Z",
    stroke: "currentColor",
    strokeWidth: 1.16621,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 12.4583C13.0878 12.4583 14.375 11.1711 14.375 9.58325C14.375 7.99543 13.0878 6.70825 11.5 6.70825C9.91218 6.70825 8.625 7.99543 8.625 9.58325C8.625 11.1711 9.91218 12.4583 11.5 12.4583Z",
    stroke: "currentColor",
    strokeWidth: 1.16621,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPoint);
export default __webpack_public_path__ + "static/media/location-point.26f7137b.svg";
export { ForwardRef as ReactComponent };